<pos-app-spinner [show]="loading"></pos-app-spinner>
<div [ngClass]="getScreenStatus() ? 'dhx_cal_container_week' : 'dhx_cal_container_week'">
  
  <div class="product-spotlight-container navbar-fixed-top">
    <div class="row align-items-center"  style="background-color: green; color: white; z-index: 100">
      <div *ngIf="fullScreen" class="col-sm-1 logo-image mt-2"></div>
      <div class="row col-md-1 pt-4" style="margin-left: 10x; margin-top: -6px">
        <label style="margin-left: 1px;" >WORKSHOP:{{part}}</label>
        <div
          class="row"
   
          [ngStyle]="{ 'margin-left': fullScreen ? '-70px' : '-1px' }"
        >
          <button
            *ngIf="!fullScreen"
            [ngStyle]="{ 'background-color': part?.toString() === '1' ? 'skyblue' : '' }"
            style="width: 30px; padding: 2px"
            (click)="goToWeeklyPart1View()"
          >
            1
          </button>
          <button
            *ngIf="!fullScreen"
            [ngStyle]="{ 'background-color': part?.toString() === '2' ? 'skyblue' : '' }"
            style="width: 30px; padding: 2px"
            (click)="goToWeeklyPart2View()"
          >
            2
          </button>
        </div>
      </div>
      <div *ngIf="!fullScreen" class="col-sm-3">
        <button mat-icon-button matTooltip="Previous Week" [matTooltipPosition]="'above'" class="h-75" (click)="getPreviousFiveOpenDays()">
          <mat-icon> chevron_left </mat-icon>
        </button>
        <label>{{ monthYear | uppercase }}</label>
        <button mat-icon-button matTooltip="Next Week" [matTooltipPosition]="'above'" class="h-75" (click)="getNextFiveOpenDays()">
          <mat-icon> chevron_right </mat-icon>
        </button>
      </div>
      <div *ngIf="fullScreen" class="col-sm-2 pt-3">
        <button
          *ngIf="!fullScreen"
          mat-icon-button
          matTooltip="Previous Week"
          [matTooltipPosition]="'above'"
          class="h-75"
          (click)="getPreviousFiveOpenDays()"
        >
          <mat-icon> chevron_left </mat-icon>
        </button>
        <label>{{ monthYear | uppercase }}</label>
        <button
          *ngIf="!fullScreen"
          mat-icon-button
          matTooltip="Next Week"
          [matTooltipPosition]="'above'"
          class="h-75"
          (click)="getNextFiveOpenDays()"
        >
          <mat-icon> chevron_right </mat-icon>
        </button>
      </div>
      <div *ngIf="dateArray" class="col-md-7 row">
        <div class="col-md-4 pt-3">
          <label>TOTAL RESOURCE AVALIABLE : </label> {{ totalResourceAvailableHours }} HRS
          <div>AH : Available Hrs</div>
        </div>
        <div class="col-md-4 pt-3">
          <label>TOTAL RESOURCE BOOKED : </label> {{ totalResourceBookedHours }} HRS
          <div>BH : Booked Hrs</div>
        </div>
        <div class="col-md-4 pt-3">
          <label>TOTAL RESOURCE HRS : </label> {{ totalResourceHours }} HRS
          <div>RH: Total Resource hour</div>
        </div>
      </div>
      <div class="col-sm-1 pt-3">
        <div class="d-flex justify-content-end">
          <div *ngIf="!fullScreen" (click)="openFullscreen()"><mat-icon> fullscreen </mat-icon></div>
          <div *ngIf="fullScreen" (click)="closeFullscreen()"><mat-icon> fullscreen_exit </mat-icon></div>
        </div>
      </div>
    </div>
  </div>
  <div>
    <div
      class="d-flex column justify-content-evenly"
      style="margin-left: 160px; border: solid 1px"
    
    >
      <div *ngFor="let day of dateArray; index as i" class="d-flex row" style="padding-left: 10px;">
        <div style="text-align: center; padding-bottom: 10px">
          <label>{{ getformattedDate(day.date) }}</label>
        </div>
        <div>
          <div class="row">
            <div class="col-sm-4"><label>AH:</label>{{ day.TotalResourceAvailableHours }}</div>
            <div class="col-sm-4"><label>BH:</label>{{ day.TotalResourceBookedHours }}</div>
            <div class="col-sm-4"><label>RH:</label>{{ day.TotalResourceHours }}</div>
          </div>
        </div>
      </div>
    </div>
    <div *ngFor="let resource of pageResource; index as j" class="flex-row" layout="row " style="background-color: lightgray">
      <div style="height: 0px; padding-left: 10px; flex-wrap: wrap">
        <label>{{ resource.resourceName }}</label>
      </div>

      <div class="d-flex column justify-content-evenly" style="margin-left: 160px; background-color: white; height: 70px">
        <div
          *ngFor="let day of dateArray; index as i"
          class="table"
          [ngStyle]="{ 'background-color': j % 2 === 0 ? 'white' : 'rgb(255, 253, 253)' }"
          style="display: flex; justify-content: center"
        >
          <div class="resource-percentage">
            <label>AH:</label> {{ getResourceAvailableHours(resource.resourceID, day) }}<br />
            <label>UP:</label>
            {{ getResourceBookedHours(resource.resourceID, day) }}
          </div>
          <div class="d-flex" style="width: 100%; overflow: hidden">
            <span *ngFor="let order of getDayOrder(resource.resourceID, day); index as k" style="height: 70px">
              <div
                *ngIf="checkTrue(order, resource.resourceID)"
                [ngStyle]="{ 'background-color': '#' + order.BackgroundColour, 'border-color': '#' + order.BorderColour }"
                style="color: white; flex-wrap: wrap; height: 68px; border-style: solid; font-size: 11px; width: 100%; border-radius: 4px"
              >
                {{ order.Description }}
                <br />
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="border-top: solid; background-color: white"><div style="position: relative; background-color: white"></div></div>
</div>
